/**
 * Company Context Plugin for Admin Contextual Panel
 *
 * Handles company pages: /companies/:slug
 */

import React from "react";
import { registerContext } from "../contextRegistry";
import MergeButton from "../MergeButton";

function CompanyContextPanel({ contextProps }) {
  const { slug } = contextProps;
  return (
    <div>
      <p className="small text-muted mb-2">Viewing company: {slug}</p>
      <div className="d-grid gap-2">
        <MergeButton />
      </div>
    </div>
  );
}

// Register this context
registerContext({
  name: "company",
  priority: 10,
  patterns: [
    {
      pattern: /\/companies\/([^/?]+)/,
      extract: (match) => ({ slug: match[1] }),
    },
  ],
  component: CompanyContextPanel,
});

export default CompanyContextPanel;
